const { pick } = require("ramda");

angular.module("ticketco/ticketbuyer/retrieve_tickets")
  .factory("RetrieveTicketsPersistence", RetrieveTicketsPersistence);

function RetrieveTicketsPersistence($http, Locale) {
  var permittedParams = pick(["email", "phone", "token", "organizer_id"]);

  function url() {
    return Locale.url("/retrieve_items");
  }

  function retrieve(obj) {
    return $http.post(url(), permittedParams(obj));
  }

  return {
    retrieve: retrieve,
  };
}
